import { productPresentation } from './productPresentation';

const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

// Remove dose annotations only, never compound identifiers (BPC-157, IGF-1).
export function compoundFamily(product) {
  return String(product.name || '').replace(/\d+(?:\.\d+)?\s*(?:mcg|µg|mg|g|iu|ml)\b/gi, '')
    .replace(/\(\s*\d+(?:\.\d+)?(?:\s*\+\s*\d+(?:\.\d+)?)+\s*\)/g, '')
    .replace(/\s+/g, ' ').trim();
}

export function strengthOrder(product) {
  const { strength } = productPresentation(product);
  // Concentrations are a distinct dimension; never compare mg/mL with mg.
  const concentration = strength.match(/^(\d+(?:\.\d+)?)\s*(mg|mcg|µg)\s*\/\s*ml\b/i);
  if (concentration) return ['concentration', Number(concentration[1]) * (/mg/i.test(concentration[2]) ? 1 : .001)];
  const parts = strength.split('+').map(part => part.trim().match(/^(\d+(?:\.\d+)?)\s*(mcg|µg|mg|g|iu|ml)$/i));
  if (parts.some(part => !part)) return ['unknown', Infinity];
  const units = parts.map(part => part[2].toLowerCase());
  const mass = units.every(unit => ['mcg', 'µg', 'mg', 'g'].includes(unit));
  if (!mass && !units.every(unit => unit === units[0])) return ['unknown', Infinity];
  return [mass ? 'mass' : units[0], parts.reduce((sum, part) => sum + Number(part[1]) *
    ({ mcg: .001, 'µg': .001, mg: 1, g: 1000 }[part[2].toLowerCase()] || 1), 0)];
}

export function sortCatalogProducts(products) {
  return [...products].sort((a, b) => {
    const family = collator.compare(compoundFamily(a), compoundFamily(b));
    if (family) return family;
    const [aUnit, aStrength] = strengthOrder(a);
    const [bUnit, bStrength] = strengthOrder(b);
    const unit = aUnit === bUnit ? 0 : aUnit === 'unknown' ? 1 : bUnit === 'unknown' ? -1 : collator.compare(aUnit, bUnit);
    return unit || (aStrength - bStrength || 0) || collator.compare(a.sku || '', b.sku || '');
  });
}
